import React, { useState, Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Tooltip,
  Spinner,
} from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import { withRouter } from "react-router";
import { Preview } from "../../../../helpers/ui/FileInput";
import apiResponse from "../../../../services/apiResponse";

import DetailBloc from "./Blocs/DetailBloc";
import { count } from "rxjs";

class IndexView extends Component {
  detailBloc = new DetailBloc();

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      tooltipStyle: {
        marginBottom: 2,
        backgroundColor: "#000",
        color: "#FFF",
        border: "1px solid #000",
      },
      pegawai_uuid: "",
      loadingDocument: true,
      dokumen_persyaratan: [],
    };
  }

  componentDidMount() {
    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              detail: response,
              pegawai_uuid: response.emp_retired_sk_employe_uuid,
            });
            debugger;
            console.log(this.state.detail);
            this.detailBloc.fetchDocument({
              uuid: response.emp_retired_sk_employe_uuid,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.detailBloc.documentChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingDocument: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              dokumen_persyaratan: response.result,
              loadingDocument: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchDetail({ uuid: queryParams.get("uuid") });
  }

  render() {
    return (
      <Fragment>
        <style>
          {`
            .custom-arrow::before {
              content: "";
              position: absolute;
              width: 0;
              height: 0;
              border-top: 6px solid transparent;
              border-bottom: 6px solid transparent;
              border-right: 6px solid #000; /* Same color as tooltip background */
              top: 50%; /* Position arrow at the vertical center */
              left: -5px; /* Adjust position from the left */
              transform: translateY(-50%); /* Center the arrow vertically */
            }
          `}
        </style>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Detail SK Pemberhentian</CardTitle>
                  <CardSubtitle className="mb-3">
                    Informasi Detail Pemberhentian
                  </CardSubtitle>
                  <hr />

                  <Row className="mb-3">
                    <label className="col-md-3">NIP</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_nip !== ""
                            ? this.state.detail.employee_nip
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Nama</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_name !== ""
                            ? this.state.detail.employee_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Jenis</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_type_stop_name !== ""
                            ? this.state.detail.retired_type_stop_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Posisi</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_position_name !== ""
                            ? this.state.detail.employee_position_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Unit Kerja</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_work_unit_name !== ""
                            ? this.state.detail.employee_work_unit_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Tempat KPPN</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_kppn_place !== ""
                            ? this.state.detail.retired_employee_kppn_place
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Bank</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_bank_name !== ""
                            ? this.state.detail.retired_employee_bank_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Nomor Rekening</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.retired_employee_bank_number !== ""
                            ? this.state.detail.retired_employee_bank_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Tanggal Pemberhentian</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.emp_retired_sk_date_tmt !== ""
                            ? this.state.detail.emp_retired_sk_date_tmt
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Sisa Masa Kerja</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_work_age !== ""
                            ? this.state.detail.employee_work_age
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">TMT Pemberhentian</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.emp_retired_sk_date_tmt !== ""
                            ? this.state.detail.emp_retired_sk_date_tmt
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">No BKN</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.emp_retired_sk_bkn_number !== ""
                            ? this.state.detail.emp_retired_sk_bkn_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Tanggal BKN</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.emp_retired_sk_bkn_date !== ""
                            ? this.state.detail.emp_retired_sk_bkn_date
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Nomor SK Pemberhentian</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.emp_retired_sk_number !== ""
                            ? this.state.detail.emp_retired_sk_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">
                      Dokumen SK Pemberhentian{" "}
                    </label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.document_sk ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              class="btn btn-sm btn-primary"
                              href={
                                this.state.detail.document_sk.documents_path
                              }
                            >
                              <i className="uil-file-download"></i> Download
                              File
                            </a>
                          ) : (
                            "Tidak ada dokumen"
                          )}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Dokumen Pertek BKN </label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.document_pertek ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              class="btn btn-sm btn-primary"
                              href={
                                this.state.detail.document_pertek.documents_path
                              }
                            >
                              <i className="uil-file-download"></i> Download
                              File
                            </a>
                          ) : (
                            "Tidak ada dokumen"
                          )}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  {this.state.loadingDocument ? (
                    <Row className="mb-3">
                      <label className="col-md-3">Dokumen Pertek BKN </label>
                      <Col md="6">
                        <Spinner className=" text-center" color="primary" />
                        <div>Memuat Dokumen</div>
                      </Col>
                    </Row>
                  ) : // <div
                  //   className="md-12 text-center"
                  //   style={{
                  //     alignItems: "center",
                  //     left: "50%",
                  //   }}
                  // >
                  //   <Spinner className="text-center" color="primary" />
                  //   <div>Memuat Dokumen</div>
                  // </div>
                  this.state.dokumen_persyaratan.length > 0 ? (
                    <>
                      <hr />
                      <h4>Dokumen Persyaratan</h4>
                      <br />
                      {this.state.dokumen_persyaratan.map((data, index) => (
                        <Row className="mb-3" key={index}>
                          <Col md="3">
                            <label
                              className="col-form-label"
                              id={`file-${data.uuid}`}
                            >
                              {data.label}{" "}
                              {data.is_required === 1 ? (
                                <span className="text-danger">*</span>
                              ) : (
                                ""
                              )}
                            </label>
                            <Tooltip
                              style={this.state.tooltipStyle}
                              arrowClassName="custom-arrow"
                              placement="right"
                              isOpen={this.state["file-" + data.uuid]}
                              target={`file-${data.uuid}`}
                              toggle={() => {
                                this.setState({
                                  ["file-" + data.uuid]:
                                    !this.state["file-" + data.uuid],
                                });
                              }}
                            >
                              {data.tooltip}
                            </Tooltip>
                          </Col>
                          <Col md="9">
                            {data.path ? (
                              data.path !== "" ? (
                                <a
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn btn-sm btn-primary"
                                  href={data.path}
                                >
                                  <i className="uil-file-download"></i> Download
                                  File
                                </a>
                              ) : (
                                "Tidak ada dokumen"
                              )
                            ) : (
                              <a
                                href="#"
                                className="btn btn-sm btn-secondary disabled"
                              >
                                <i className="uil-file-download"></i> Download
                                File
                              </a>
                            )}
                          </Col>
                        </Row>
                      ))}
                    </>
                  ) : (
                    <>
                      <hr />
                      <h4> Tidak Ada Dokumen Persyaratan</h4>
                      <br />
                    </>
                  )}

                  <Row className="mb-3">
                    <Col md="3"></Col>
                    <Col md="9">
                      <Link
                        to="/kepegawaian/pensiunsk.html"
                        className="waves-effect"
                      >
                        <Button color="danger">
                          <i className="uil-arrow-left"></i> Kembali
                        </Button>
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
